import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/text-cell.scss';

export default Component('tr-grid-text-cell', {
  mixins: [baseMixin],

  connected() {
    this.result = this.querySelector('.grid-text-cell-field .result');
    this.editorInput = this.querySelector('.grid-cell-editor input');

    this.listenTo(this.editorInput, {
      blur: this.handleInputBlur.bind(this),
      keydown: this.handleInputKeydown.bind(this),
    });

    this.listenTo(this, 'click', ({ target }) => {
      if (closest(target, '.grid-text-cell-field', this)) {
        this.beginEditing();
      }
    });
  },

  preventClickEvent({ target }) {
    return this.editable && this.contains(target)
      && closest(target, '.grid-text-cell-field', this);
  },

  beginEditing() {
    if (!this.editable || this.editing) return;

    this.destroyOverflowTooltip();
    this.editing = true;
    this.editorInput.value = this.value;
    this.editorInput.focus();
  },

  getTextContentElement() {
    return this.result;
  },

  triggerCellValueChange() {
    this.editing = false;

    const { value } = this.editorInput;
    if (value === this.value) return;

    this.value = value;
    this.updateResult(value);
    this.namespacedTrigger('cellValueChange', {
      detail: { value },
      bubbles: true,
    });
  },

  updateResult(content) {
    this.result.textContent = content;
  },

  handleInputBlur() {
    if (this.skipInputBlurHandler) {
      this.skipInputBlurHandler = false;
      return;
    }

    this.triggerCellValueChange();
  },

  handleInputKeydown(event) {
    if (event.isComposing || event.keyCode === 229) return;

    const isEnter = event.key === 'Enter' || event.keyCode === 13;
    const isEscape = event.key === 'Escape' || event.keyCode === 27;

    if (isEnter) {
      event.preventDefault();
      event.stopPropagation();

      this.skipInputBlurHandler = true;
      this.triggerCellValueChange();
    } else if (isEscape) {
      event.preventDefault();
      event.stopPropagation();

      this.skipInputBlurHandler = true;
      this.editing = false;
    }
  },
});
